import {Component, inject, OnInit, signal} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {AvailableOperatorGroups} from '@em/shared/mapping-engine/data-access';
import {
  DestinationAttribute,
  MappingRuleList,
} from '@em/shared/mapping-engine/domain-models';
import {EmMappingRuleListModule} from '../mapping-rule-list/mapping-rule-list.module';
import {
  EmPrimaryButtonComponent,
  EmSecondaryButtonComponent,
} from '@em/shared/ui';
import {AbstractControl} from '@angular/forms';
import {MappingEngineFormBuilderService} from '../../services/mapping-engine-form-builder/mapping-engine-form-builder.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-edit-mapping-rule-list-modal',
  templateUrl: './edit-mapping-rule-list-modal.component.html',
  styleUrls: ['./edit-mapping-rule-list-modal.component.scss'],
  imports: [
    TranslateModule,
    MatDialogModule,
    EmMappingRuleListModule,
    EmPrimaryButtonComponent,
    EmSecondaryButtonComponent,
  ],
})
export class EmEditMappingRuleListModalComponent implements OnInit {
  private readonly _matDialogRef = inject(
    MatDialogRef<EmEditMappingRuleListModalComponent>,
  );
  private readonly _fb = inject(MappingEngineFormBuilderService);

  data = inject<{
    sourceAttributes: string[] | undefined;
    customSourceAttributes: string[] | undefined;
    destinationAttributes: DestinationAttribute[] | undefined;
    arrayIndex: number;
    forceCustomWithoutFlag: boolean;
    type: 'edit' | 'add';
  }>(MAT_DIALOG_DATA);

  readonly availableOperatorGroups = AvailableOperatorGroups;
  mappingRulesFormGroup: AbstractControl | undefined;
  showInvalidError = signal(false);
  oldValue: MappingRuleList | undefined;

  get isAdd() {
    return this.data.type === 'add';
  }

  get isEdit() {
    return this.data.type === 'edit';
  }

  close(shouldDelete: boolean) {
    this._matDialogRef.close(shouldDelete);
  }

  validateAndClose() {
    if (this.mappingRulesFormGroup?.valid) {
      this.close(false);
    } else {
      this.mappingRulesFormGroup?.markAllAsDirty();
      this.mappingRulesFormGroup?.markAllAsTouched();
      this.mappingRulesFormGroup?.updateValueAndValidity();
      this.showInvalidError.set(true);
    }
  }

  ngOnInit(): void {
    this.mappingRulesFormGroup = this._fb.getMappingRuleList(
      this.data.arrayIndex,
    );

    this.oldValue = this.mappingRulesFormGroup.value;
  }

  revertChanges() {
    if (this.mappingRulesFormGroup && this.oldValue?.attribute) {
      const allRuleLIsts = this._fb.getAllMappingRuleLists();
      const currentIndex = allRuleLIsts.controls.indexOf(
        this.mappingRulesFormGroup,
      );
      this._fb.removeMappingRuleList(currentIndex);
      this._fb.addNewMappingRuleListWithValues(
        !!this.oldValue?.custom,
        this.oldValue?.attribute,
        this.oldValue?.mappingRules,
        currentIndex,
      );
      this.close(false);
    }
  }
}
